import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { trackVisit, trackView } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Story from "@/components/Story";
import PowerBanner from "@/components/PowerBanner";
import Platform from "@/components/Platform";
import Resolutions from "@/components/Resolutions";
import Referendums from "@/components/Referendums";
import VideoSection from "@/components/VideoSection";
import PhotoGallery from "@/components/PhotoGallery";
import Events from "@/components/Events";
import VoterInfo from "@/components/VoterInfo";
import Volunteer from "@/components/Volunteer";
import RidePopup from "@/components/RidePopup";
import SignupForm from "@/components/SignupForm";
import Footer from "@/components/Footer";

export default function Landing() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    if (sessionStorage.getItem("visit_tracked") !== today) {
      sessionStorage.setItem("visit_tracked", today);
      trackVisit().catch(() => {});
    }
  }, []);

  useEffect(() => {
    const SECTION_IDS = ["story", "platform", "day-one", "referendum", "film", "gallery", "events", "vote", "volunteer", "signup"];
    const seen = new Set(JSON.parse(sessionStorage.getItem("views_tracked") || "[]"));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const key = `section:${entry.target.id}`;
          if (entry.isIntersecting && !seen.has(key)) {
            seen.add(key);
            sessionStorage.setItem("views_tracked", JSON.stringify([...seen]));
            trackView(key).catch(() => {});
          }
        });
      },
      { threshold: 0, rootMargin: "-45% 0px -45% 0px" }
    );
    SECTION_IDS.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const onNavigate = (hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -64 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <main className="bg-navy">
      <Navbar onNavigate={onNavigate} />
      <Hero onNavigate={onNavigate} />
      <Marquee />
      <Story />
      <PowerBanner />
      <Platform />
      <Resolutions />
      <Referendums />
      <VideoSection />
      <PhotoGallery />
      <Events />
      <VoterInfo />
      <Volunteer onNavigate={onNavigate} />
      <SignupForm />
      <Footer onNavigate={onNavigate} />
      <RidePopup />
    </main>
  );
}
